import { LEGAL_LINKS } from '../config/legal';

// A small row of links to the published legal documents, shown under the main
// menu only.
//
// Two deliberate choices:
//
// 1. DOM, not Phaser. A canvas text object is not a link — not focusable, not
//    selectable, not openable in a new tab, invisible to a screen reader.
// 2. The CONTAINER takes pointer-events: none and only the anchors take
//    pointer-events: auto. Phaser listens for pointer events on the window, so
//    an overlay that swallows them breaks the game underneath; making the
//    container transparent to events avoids that failure mode entirely rather
//    than patching it with stopPropagation.
//
// It must work with no account system at all: a build without VITE_SUPABASE_*
// hides the account button, so this row is then the ONLY way a player can
// reach the privacy policy.

const ID = 'legal-footer';

function build(): HTMLDivElement {
  const row = document.createElement('div');
  row.id = ID;
  row.hidden = true;
  LEGAL_LINKS.forEach((link, i) => {
    if (i) row.append(document.createTextNode(' · '));
    const a = document.createElement('a');
    a.href = link.href;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.textContent = link.label;
    row.append(a);
  });
  document.body.append(row);
  return row;
}

function node(): HTMLDivElement {
  return (document.getElementById(ID) as HTMLDivElement | null) ?? build();
}

/** Show the row — call from MenuScene.create(). */
export function showLegalFooter(): void {
  node().hidden = false;
}

/** Hide the row — call on MenuScene shutdown, so it never sits over the board. */
export function hideLegalFooter(): void {
  node().hidden = true;
}
